import apple from './apple.svg';
import book from './book.svg';
import book_2 from './book_2.svg';
import computer from './computer.svg';
import diploma from './diploma.svg';
import gear from './gear.svg';
import hat from './hat.svg';
import lab from './lab.svg';
import notebook from './notebook.svg';
import person from './person.svg';
import presentation from './presentation.svg';
import presentation_2 from './presentation_2.svg';
import qa from './qa.svg';
import rolled from './rolled.svg';
import ruler from './ruler.svg';
import tablet from './tablet.svg';
import talking from './talking.svg';

export { 
  apple,
  book,
  book_2,
  computer,
  diploma,
  gear,
  hat,
  lab,
  notebook,
  person,
  presentation,
  presentation_2,
  qa,
  rolled,
  ruler,
  tablet,
  talking,
};